import { BaseApi } from "./base-api";

const resourceKey = "virtual_folders";

export const VirtualFoldersApi = {
  retrieve: (pk: number) => BaseApi.retrieve(resourceKey, pk),
  update: (pk: number, params: any) => BaseApi.update(resourceKey, pk, params),
};
